export class ServiceNowTicket {
  shortDescription: string;
  description: string;
  sender: string;
  attachments: AttachmentsTicket[] = [];
}

export class AttachmentsTicket {
  filename: string;
  contentType: string;
  base64Data: string;
}
